import { createSelector, createFeatureSelector } from '@ngrx/store';
import * as fromRoot from '../../../app/state/app.selectors';
import * as fromOverrideReporting from './override-reporting.reducers';

export interface OverrideReportingState {
  stateData: fromOverrideReporting.State;
}

export interface State extends fromRoot.AppState {
  overrideReporting: OverrideReportingState;
}

export const reducers = {
  stateData: fromOverrideReporting.reducer
};

export const selectOverrideReportingState = createFeatureSelector<OverrideReportingState>('overrideReporting');

export const selectOverrideReportingStateData = createSelector(selectOverrideReportingState, (state: OverrideReportingState) => state.stateData);

export const getOverrideReportingState = createSelector(selectOverrideReportingStateData, fromOverrideReporting.getStateData);

export const getOverrideReportingScreenError = createSelector(selectOverrideReportingStateData, fromOverrideReporting.getError);

export const getOverrideReportingScreenPending = createSelector(selectOverrideReportingStateData, fromOverrideReporting.getPending);